module.exports = __webpack_public_path__ + "img/empresa.f8a1554f.png";